import React from 'react';
import { enumLabels } from '../../lib/enums.js';

// Styles are keyed by enum *value*; the display labels come from AppEnums via
// enumLabels(), so neither can drift from the server's single source of truth.
const SENTIMENT_STYLE = {
  positive: { bg: '#E8F2EC', fg: '#1F6B41' },
  concern:  { bg: '#F7E6E6', fg: '#9B1F26' }
};

const STATUS_STYLE = {
  open:        { bg: '#F2EEE6', fg: '#7E5C16' },
  in_progress: { bg: '#EEF1F5', fg: '#3E4A5C' },
  resolved:    { bg: '#EFEDE3', fg: '#6B6B68' }
};

// `severity` and `status` are raw enum values (e.g. 'medium', 'in_progress').
export default function FeedbackPill({ sentiment, severity, status }) {
  const meta = SENTIMENT_STYLE[sentiment] || SENTIMENT_STYLE.concern;
  const stat = STATUS_STYLE[status] || { bg: '#F0EFE9', fg: '#6B6B68' };
  const sentimentLabel = enumLabels('feedback_sentiment')[sentiment] || '';
  const severityLabel  = severity ? enumLabels('feedback_severity')[severity] : '';
  const statusLabel    = status ? enumLabels('feedback_status')[status] : '';
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="inline-flex items-center text-[11px] px-2 py-0.5 rounded-full"
            style={{ background: meta.bg, color: meta.fg, fontWeight: 500 }}>
        {sentimentLabel}{severityLabel && sentiment === 'concern' ? ` · ${severityLabel}` : ''}
      </span>
      <span className="inline-flex items-center text-[11px] px-2 py-0.5 rounded-full"
            style={{ background: stat.bg, color: stat.fg }}>
        {statusLabel}
      </span>
    </span>
  );
}
